import { useCsvFileAnalyses } from '../../hooks/useCsvFileAnalyses';
import { useCsvTableOperations } from '../../hooks/useCsvTableOperations';
import { AnalysisCard } from './AnalysisCard';
import { AnalysisList } from './AnalysisList';
import { Spinner } from '@/components/ui/Spinner';

export const AnalysisDashboard = () => {
  const { analyses, isLoading, handleDelete, refetch } = useCsvFileAnalyses();
  const { processingId, handleGenerateSchema, handleImportData } = useCsvTableOperations(refetch);
  
  if (isLoading) {
    return (
      <div className="min-h-[200px] flex items-center justify-center">
        <Spinner size="md" variant="muted" ariaLabel="Loading analyses" />
      </div>
    );
  }

  if (!analyses?.length) {
    return (
      <div className="min-h-[200px] flex flex-col items-center justify-center text-muted-foreground">
        <p>No files analyzed yet</p>
        <p className="text-sm">Upload a CSV file to get started</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Analysis Results</h2>
      
      <div className="grid grid-cols-1 gap-6">
        {analyses.map((analysis) => (
          <AnalysisCard
            key={analysis.id}
            analysis={analysis}
            onDelete={() => handleDelete(analysis.id, analysis.file_path)}
            onGenerateSchema={handleGenerateSchema}
            onImportData={handleImportData}
            isProcessing={processingId === analysis.id}
            onAnalysisComplete={refetch}
          />
        ))}
      </div>
    </div>
  );
};